module.exports = __webpack_public_path__ + "static/what-we-do-mobile2-92ec37eb098c8bbc7246c3d2c47f06f9.webp";